export const COOKIE_KEYS = {
  LOGIN_INFO: 'loginInfo',
};

export const BOX_MAP_DOMAIN = 'box.tap30.services';
export const BOX_MAP_PROXY_DOMAIN = '/products/delivery/map-service';

export const SESSION_STORAGE_KEYS = {
  DELIVERY_REQUEST_PAYMENT_INFO: 'DRPI',
};

export const BASE_PATH = import.meta.env.VITE_BASE_PATH || '/';

export const APPLICATION_PATH = 'app';

export const MAX_DESTINATIONS = 3;

export const VALIDATION_REGEXS = {
  PHONE_NUMBER: /^[0\u06F0](?![0\u06F0])[\d\u06F0-\u06F9]{10}$/,
  PERSIAN: /^[\u0600-\u06FF\u06F0-\u06F9\u200C\s.,،؛!?؟()'"«»/\-—…0-9]*$/,
  BUILDING_NUMBER: /^[a-zA-Z0-9\u0600-\u06FF]+$/,
  WEBSITE: /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})[/\w .-]*\/?$/,
};

export const SUPPORT_NUMBER = '1630';

export const WEBENGAGE_EVENT_KEYS = {
  APP_OPEN: 'box_app_open',
  SEARCH_ADDRESS_CLICKED: 'box_search_address_clicked',
  PARTY_SUGGESTION: 'box_party_suggestion',
} as const;

export const SOURCE_APP_STORAGE_KEY = 'BOX__SOURCE_APP';
